import { useFormik } from "formik";
import InputCustom from "../../InputCustom/InputCustom";
import styles from "./ContactForm.module.scss";
import validationSchema from "../../../models/ContactSchema";
import Button from "../../Button/Button";
import { useState } from "react";
import { sendContactEmail } from "../../../api/contact";
import { Link } from "react-router-dom";
import Honeypot from "../Honeypot/Honeypot";
import { toast } from "react-toastify";

function ContactForm() {
  const [honeypot, setHoneypot] = useState("");

  const onSubmit = async (formValues) => {
    if (honeypot) {
      return;
    }

    try {
      const response = await sendContactEmail({
        ...formValues,
        website: honeypot,
      });
      if (response && response.status === 200) {
        toast.success("Votre message a été envoyé avec succès.");
        formik.resetForm();
      }
    } catch (error) {
      console.error(
        "Erreur lors de l'envoi du formulaire de contact : ",
        error,
      );
      toast.error(
        error.response?.data?.message || "Une erreur est survenue.",
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      message: "",
    },
    validationSchema,
    onSubmit,
  });

  return (
    <div className={styles.container}>
      <h2>Formulaire de contact</h2>
      <form onSubmit={formik.handleSubmit}>
        <div className={styles.row}>
          <div>
            <InputCustom
              id="lastName"
              type="text"
              name="lastName"
              placeholder="Nom"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.lastName}
              style={{ marginTop: "10px" }}
            />
            {formik.touched.lastName && formik.errors.lastName ? (
              <div className={styles.error}>{formik.errors.lastName}</div>
            ) : null}
          </div>
          <div>
            <InputCustom
              id="firstName"
              type="text"
              name="firstName"
              placeholder="Prénom"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.firstName}
              style={{ marginTop: "10px" }}
            />
            {formik.touched.firstName && formik.errors.firstName ? (
              <div className={styles.error}>{formik.errors.firstName}</div>
            ) : null}
          </div>
        </div>
        <div>
          <InputCustom
            id="email"
            type="text"
            name="email"
            placeholder="Email"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            style={{ marginTop: "10px" }}
          />
          {formik.touched.email && formik.errors.email ? (
            <div className={styles.error}>{formik.errors.email}</div>
          ) : null}
        </div>
        <textarea
          name="message"
          id="message"
          placeholder="Message"
          rows="12"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.message}
        ></textarea>
        {formik.touched.message && formik.errors.message ? (
          <div className={styles.error}>{formik.errors.message}</div>
        ) : null}
        <p className={styles.consentInfo}>
          En envoyant ce message, vos informations sont utilisées uniquement
          pour vous répondre. Voir notre{" "}
          <Link to="/legal" target="_blank" rel="noopener noreferrer">
            politique de confidentialité
          </Link>
          .
        </p>

        <Honeypot
          value={honeypot}
          onChange={(e) => setHoneypot(e.target.value)}
        />

        <div className={styles.btnContainer}>
          <Button
            disabled={formik.isSubmitting}
            type="submit"
            color="var(--primary-color)"
          >
            {formik.isSubmitting ? "Envoi en cours..." : "Envoyer"}
          </Button>
        </div>
      </form>
    </div>
  );
}

export default ContactForm;
